// Patches Pixi to avoid `new Function()` so it works under our strict CSP

// (script-src 'self', no unsafe-eval). Must run before any Pixi renderer is

// created — keep it as the very first import. Side-effect only (self-installs).

import "pixi.js/unsafe-eval";

import ReactDOM from "react-dom/client";

import * as Sentry from "@sentry/react";

import "./main.css";

import Root from "./Root";

import { track } from "./lib/umami";

// Error tracking (Sentry Cloud, org eriolio / US region). Inert sin DSN

// (VITE_SENTRY_DSN unset en dev/CI). Sin PII (sendDefaultPii:false) y beforeSend

// borra datos de usuario/cookies antes de enviar.

if (import.meta.env.VITE_SENTRY_DSN) {
  Sentry.init({
    enableLogs: true,

    integrations: [
      Sentry.consoleLoggingIntegration({ levels: ["warn", "error"] }),

      Sentry.replayIntegration({
        maskAllText: true,

        maskAllInputs: true,

        blockAllMedia: true,
      }),
    ],

    replaysSessionSampleRate: 1.0,

    replaysOnErrorSampleRate: 1.0,

    dsn: import.meta.env.VITE_SENTRY_DSN,

    environment: import.meta.env.MODE,

    release: import.meta.env.VITE_SENTRY_RELEASE,

    tracesSampleRate: 0.05,

    sendDefaultPii: false,

    beforeSend(event) {
      delete event.user;

      if (event.request) delete event.request.cookies;

      return event;
    },
  });
}

const isStandalone =
  typeof window !== "undefined" &&
  (window.matchMedia?.("(display-mode: standalone)").matches ||
    // iOS Safari home-screen install

    (window.navigator as { standalone?: boolean }).standalone === true);

if (isStandalone) {
  track("pwa_session_started");
}

window.addEventListener("appinstalled", () => {
  track("pwa_installed");
});

window.addEventListener("error", (event) => {
  track("error_unhandled", {
    message: (event.message ?? "").slice(0, 200),

    source: "mobile_window_error",
  });
});

window.addEventListener("unhandledrejection", (event) => {
  const reason = event.reason;

  const message =
    reason instanceof Error ? reason.message : String(reason ?? "unknown");

  track("error_unhandled", {
    message: message.slice(0, 200),

    source: "mobile_unhandled_rejection",
  });
});

ReactDOM.createRoot(document.getElementById("root")!).render(
  <Sentry.ErrorBoundary fallback={<p>Algo salió mal.</p>}>
    <Root />
  </Sentry.ErrorBoundary>,
);
